import { render, staticRenderFns } from "./modalTipoHistorias.vue?vue&type=template&id=3d245e20&"
import script from "./modalTipoHistorias.vue?vue&type=script&lang=js&"
export * from "./modalTipoHistorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports